import { Card, Descriptions, LicensePlate } from "@rumbledirect/ui";
import {
  Card as V2Card,
  CardHeader,
  CardTitle,
  CardContent,
  DescriptionList,
  LicensePlate as V2Plate,
} from "@rumbledirect/ui-v2";
import { formatDateOrEmpty } from "@rumbledirect/ui-v2/format";

export interface DisplayCardProps {
  title: string;
  uiV2?: boolean;
  headerImage?: {
    src: string;
    alt: string;
  };
  items: Array<{
    key: string;
    label: string;
    displayType?: "licensePlate" | "string" | "date";
    value: string;
  }>;
}

export const DisplayCard = ({ title, items, uiV2 }: DisplayCardProps) => {
  if (uiV2)
    return (
      <V2Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <DescriptionList
            items={items.map((item) => ({
              key: item.key,
              label: item.label,
              value:
                item.displayType === "licensePlate" ? (
                  <V2Plate value={item.value} />
                ) : item.displayType === "date" ? (
                  formatDateOrEmpty(item.value)
                ) : (
                  item.value
                ),
            }))}
          />
        </CardContent>
      </V2Card>
    );
  return (
    <Card title={title}>
      <Descriptions
        items={items.map((item) => ({
          key: item.key,
          label: item.label,
          children:
            item.displayType === "licensePlate" ? (
              <LicensePlate>{item.value}</LicensePlate>
            ) : item.displayType === "date" ? (
              formatDateOrEmpty(item.value)
            ) : (
              item.value
            ),
        }))}
      />
    </Card>
  );
};
